import React, { useState } from 'react';
import {
    Container,
    FilledInput,
    Box,
    Button,
    Grid,
    NativeSelect,
    IconButton,
    InputAdornment
} from '@material-ui/core';
import Dialog from '../../../../views/dialog';
import useStyles from './style';
import matchArrowIcon from '../../../../assets/integration-builder/match-arrow.png';
import { Messages } from '../../resources/resources/js/message';
import { configMessage } from '../../../../common/messages/config';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';

export default function MatchFields(props) {
    const { show, close, leftFields = [], rightFields = [], allRightFieldValues = [], tableMappingType, mapType } = props;
    const classes = useStyles();

    const [leftFieldInputValues, setLeftFieldInputValues] = useState({});
    const [rightFieldSelectedValues, setRightFieldSelectedValues] = useState({});
    const [showSearch, setShowSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const fieldPairs = leftFields.map((left, index) => ({
        left,
        right: rightFields[index] ?? '',
        originalIndex: index
    }));

    const filteredPairs = showSearch
        ? fieldPairs.filter(p => p.left.toLowerCase().includes(searchQuery.toLowerCase()))
        : fieldPairs;

    const tableMapdropdownValues = allRightFieldValues.includes(Messages.E006)
        ? allRightFieldValues
        : [...allRightFieldValues, Messages.E006];

    const modalTitle = () => (
        <Box id="scroll-dialog-title">
            <h2 id="modal-title">{configMessage.T4721}</h2>
        </Box>
    );

    const handleLeftFieldInputChange = (event) => {
        const { name, value } = event.target;
        setLeftFieldInputValues(prev => ({ ...prev, [name]: value }));
    };

    const handleRightFieldsChange = (event) => {
        const { name, value } = event.target;
        setRightFieldSelectedValues(prev => ({ ...prev, [name]: value }));
    };

    const mapTwoData = (leftObj, rightObj, type) => {
        let matchFields = {};
        let i = 0;
        for (let item in leftObj) {
            let j = 0;
            for (let item2 in rightObj) {
                if (j > i) break;
                j++;
                matchFields[leftObj[item]] = rightObj[item2];
            }
            i++;
        }
        props.matchFields(matchFields);
    };

    const replaceNewValues = (changedValues, baseArray) => {
        let updatedArray = [...baseArray];
        for (let key in changedValues) {
            const idx = parseInt(key.split('-').pop(), 10);
            if (!Number.isNaN(idx)) {
                updatedArray[idx] = changedValues[key];
            }
        }
        return updatedArray;
    };

    const newArrayData = (arrayData, type) => {
        let newObj = {};
        for (let [index, item] of arrayData.entries()) {
            newObj[`${type}Value-${index}`] = item;
        }
        return newObj;
    };

    const handleMatchFields = () => {
        const leftChanged = Object.keys(leftFieldInputValues).length > 0;
        const rightChanged = Object.keys(rightFieldSelectedValues).length > 0;

        let leftNewValues, rightNewValues;

        if (leftChanged && rightChanged) {
            leftNewValues = replaceNewValues(leftFieldInputValues, leftFields);
            rightNewValues = replaceNewValues(rightFieldSelectedValues, rightFields);
            mapTwoData(newArrayData(leftNewValues, 'left'), newArrayData(rightNewValues, 'right'), 'new');
        } else if (leftChanged) {
            leftNewValues = replaceNewValues(leftFieldInputValues, leftFields);
            mapTwoData(newArrayData(leftNewValues, 'left'), newArrayData(rightFields, 'right'), 'left');
        } else if (rightChanged) {
            rightNewValues = replaceNewValues(rightFieldSelectedValues, rightFields);
            mapTwoData(newArrayData(leftFields, 'left'), newArrayData(rightNewValues, 'right'), 'right');
        } else {
            mapTwoData(newArrayData(leftFields, 'left'), newArrayData(rightFields, 'right'), 'old');
        }

        props.toggleMatchFields('', 'updatetype1');
        close();
    };

    const findIfDataPresent = (value, arr = []) => arr.includes(value);

    const fetchFieldsData = () => {
        const leftTableName = props.tableNames?.leftTable;
        const rightTableName = props.tableNames?.rightTable;

        const effectiveRightFields = filteredPairs
        .map(fp => {
            const fpKey = `rightValue-${fp.originalIndex}`;
            return rightFieldSelectedValues[fpKey] ?? rightFields[fp.originalIndex] ?? "";
        })
        .filter(Boolean);

        return (
            <Container className={classes.mainContainer}>
                <Grid>
                    <Box>
                        {showSearch ? (
                            <FilledInput
                                variant="outlined"
                                placeholder={`Search ${leftTableName} fields...`}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ width: '90%', marginTop: '8px', paddingRight: '0px' }}
                                disableUnderline
                                  endAdornment={
                                    <InputAdornment position="end">
                                    <IconButton
                                        size="small"
                                        onClick={() => setShowSearch(false)}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                    </InputAdornment>
                                }
                            />
                        ) : (
                            <Box display="flex" alignItems="center" width="90%">
                            <label className={classes.fieldName}>
                                {leftTableName}
                            </label>
                            <SearchIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => setShowSearch(prev => !prev)}
                            />
                            </Box>
                        )}

                        {filteredPairs.map(pair => {
                            const originalIndex = pair.originalIndex;
                            return (
                                <Box key={`left-${originalIndex}`}>
                                    <FilledInput
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        defaultValue={pair.left}
                                        name={`leftValue-${originalIndex}`}
                                        className={classes.leftField}
                                        contentEditable={false}
                                        disabled={true}
                                        disableUnderline
                                        onChange={handleLeftFieldInputChange}
                                    />
                                    <img
                                        src={matchArrowIcon}
                                        className={
                                            mapType?.toLowerCase() !== 'set'
                                                ? classes.arrowIcon
                                                : `${classes.arrowIcon} ${classes.rightArrowIcon}`
                                        }
                                        alt="->"
                                    />
                                </Box>
                            );
                        })}
                    </Box>
                </Grid>

                <Grid>
                    <Box>
                        <label className={classes.fieldName}>
                            {rightTableName}
                        </label>

                        {filteredPairs.map(pair => {
                            const originalIndex = pair.originalIndex;
                            const key = `rightValue-${originalIndex}`;
                            const selected = rightFieldSelectedValues[key] ??
                                (findIfDataPresent(pair.right, tableMapdropdownValues) ? pair.right : Messages.E006);

                            return (
                                <Box key={`right-${originalIndex}`}>
                                    <NativeSelect
                                        id={`authType-${originalIndex}`}
                                        disableUnderline
                                        placeholder="Select"
                                        className={classes.leftField}
                                        name={key}
                                        onChange={handleRightFieldsChange}
                                        value={selected}
                                        disabled={tableMappingType === 'show'}
                                    >
                                    {tableMapdropdownValues.map((childItem, idx) => {
                                        const isAlreadySelected =
                                        childItem !== Messages.E006 &&
                                        effectiveRightFields.includes(childItem) &&
                                        childItem !== selected;

                                        return (
                                            <option key={idx} value={childItem}>
                                                {isAlreadySelected
                                                    ? `✅ ${childItem}`
                                                    : `\u2007\u2007 ${childItem}`}
                                            </option>
                                        );
                                    })}
                                    </NativeSelect>
                                </Box>
                            );
                        })}
                    </Box>
                </Grid>
            </Container>
        );
    };

    const container = () => (
        <Grid xs={12}>
            {fetchFieldsData()}
        </Grid>
    );

    const footer = () => (
        <Box className="match-fields-footer">
            <Button variant="contained" color="secondary" onClick={close} id="close_match_field_dialog">
                Cancel
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={handleMatchFields}
                disabled={tableMappingType === 'show'}
            >
                Save
            </Button>
        </Box>
    );

    return (
        <Dialog
            open={show}
            onClose={close}
            maxWidth={'md'}
            fullWidth={true}
            dialogTitle={modalTitle()}
            dialogoContent={container()}
            dialogFooter={footer()}
        />
    );
}
